import { z } from "zod";
import { BaseOverlayConfig } from "../shared/config";
import { defineOverlay } from "../shared/functions";
const ballTypes = [
    "pizza",
    "football",
    "heart",
    "tie-dye",
    "spaceship",
    "green-butterfly",
    "ufo",
    "default",
];
export const BallPitOverlay = defineOverlay({
    defaults: {
        ballType: "default",
        debugMode: false,
        maxAmount: 100,
        maxBalls: 300,
        maxScale: 15,
        minAmount: 1,
        randomColors: false,
        scaleSize: true,
        showAllDonations: false,
        startScale: 10,
    },
    details: {
        category: "overlay",
        description: "Display a physics-enabled ball pit that fills with more balls as more donations come in.",
        features: [
            "Shows scale of donations with ball sizing",
            "Randomized colors",
        ],
        flags: {
            isFeatured: false,
            isNew: true,
            isUpdated: false,
            isVisible: true,
        },
        icon: "overlays/ball-pit.png",
        name: "Ball Pit",
        path: "/overlays/ball-pit/",
        shortDescription: "Display a physics-enabled ball pit that fills with more balls as more donations come in.",
        slug: "ball-pit",
    },
    schema: BaseOverlayConfig.extend({
        ballType: z
            .enum(ballTypes)
            .default(() => BallPitOverlay._config.defaults.ballType)
            .optional(),
        maxAmount: z
            .number()
            .int()
            .min(1)
            .default(() => BallPitOverlay._config.defaults.maxAmount)
            .optional(),
        maxBalls: z
            .number()
            .int()
            .min(1)
            .default(() => BallPitOverlay._config.defaults.maxBalls)
            .optional(),
        maxScale: z
            .number()
            .min(1)
            .default(() => BallPitOverlay._config.defaults.maxScale)
            .optional(),
        minAmount: z
            .number()
            .int()
            .min(1)
            .default(() => BallPitOverlay._config.defaults.minAmount)
            .optional(),
        randomColors: z
            .boolean()
            .default(() => BallPitOverlay._config.defaults.randomColors)
            .optional(),
        scaleSize: z
            .boolean()
            .default(() => BallPitOverlay._config.defaults.scaleSize)
            .optional(),
        showNames: z
            .boolean()
            .default(() => BallPitOverlay._config.defaults.showNames)
            .optional(),
        startScale: z
            .number()
            .min(1)
            .default(() => BallPitOverlay._config.defaults.startScale)
            .optional(),
    }).transform((data) => {
        if (data.startScale !== undefined &&
            data.maxScale !== undefined &&
            data.startScale > data.maxScale) {
            data.maxScale = data.startScale + 5;
        }
        return data;
    }),
});
//# sourceMappingURL=ball-pit.js.map